/*
 * HomePage
 */

import React from 'react';

// Material Resources

// Others
import { Switch, Route, useRouteMatch } from 'react-router-dom';

// Components & Others
import NotFound from '../../NotFoundPage';
import BankList from '../../../components/Models/Bank/BankList';
import BankEdit from '../../../components/Models/Bank/BankCreateEdit/edit';
import BankForm from '../../../components/Models/Bank/BankForm';

function BankPage() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path} component={BankList} />
      <Route path={`${path}/crear`} component={BankForm} />
      <Route path={`${path}/:id`} component={BankEdit} />
      <Route path="" component={NotFound} />
    </Switch>
  );
}

export default BankPage;
